// Zone codes an account may still store that the current picker list no longer offers.
//
// timezones-list 3.0.2 shipped two corrupt codes with a place name run into the zone
// name, and listed Ukraine's zone under its pre-2022 spelling. Version 3.0.3 corrects all
// three. An account that saved one of the old codes would otherwise open its settings to
// a blank timezone field, because the picker finds no entry with that code.
//
// The backend resolves every one of these names (src/time/index.ts, TIMEZONE_ALIASES), so
// a stored legacy code still works. This map only lets the picker show and re-save it
// under its current code.
const LEGACY_TIMEZONE_CODES = {
  'America/AnguillaSandy Hill': 'America/Anguilla',
  'Pacific/GuamVillage': 'Pacific/Guam',
  'Europe/Zaporozhye': 'Europe/Zaporizhzhia',
};

/**
 * The current picker code for a stored timezone. Codes the list still offers come back
 * unchanged, as does anything that is not a string.
 */
export function currentTimezoneCode(code) {
  if (typeof code !== 'string') return code;
  return LEGACY_TIMEZONE_CODES[code] || code;
}
